import React from 'react';
import { Button, CloseButton, Modal, Spinner } from 'react-bootstrap';

const SystemAlert = ({ title, bodyText, cancelText, confirmText, confirmWaiting = false, confirmColor = 'primary', modalShow, setModalShow, position = 'center', ...rest }) => {
	const { handleConfirm } = rest;
	const isTop = position === 'top';
	return (
		<Modal
			show={modalShow}
			onHide={() => setModalShow(false)}
			backdrop='static'
			keyboard={false}
			centered={!isTop}
			className='modal-nested-stack'
			backdropClassName='modal-backdrop-nested'
			dialogClassName={isTop ? 'mt-4' : undefined}
		>
			<Modal.Header>
				<Modal.Title>{title}</Modal.Title>
				<CloseButton onClick={() => setModalShow(false)} />
			</Modal.Header>
			<Modal.Body>{bodyText}</Modal.Body>
			<Modal.Footer>
				<Button variant='secondary' onClick={() => setModalShow(false)}>
					<span className='fs-9'>{cancelText}</span>
				</Button>
				<Button variant={confirmColor} onClick={handleConfirm}>
					<span className='fs-9'>{confirmWaiting ? <Spinner size='sm' /> : confirmText}</span>
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default SystemAlert;
